define(["data/config"], function(config) {
    var apply = function() {

        var hash = window.location.hash.substring(1);
        if(hash) {
            var $currentTab = $(".c_navigationTabs ul li.is-active");
            var currentId = $currentTab.attr("id").replace(/-tab/, "");
            hideTab(currentId);
            showTab(hash);
        }

        $(".c_navigationTabs ul li").each(function() {
            $(this).click(function(e) {
                if(!$(this).find('a').attr('href')) {
                    e.preventDefault();
                    var $currentTab = $(this).parents('.c_navigationTabs').find('.is-active')
                    var currentId = $currentTab.attr("id").replace(/-tab/, "");
                    var newId = $(this).attr("id").replace(/-tab/, "");
                    hideTab(currentId);
                    showTab(newId);
                    changeLocation(newId);
                }
            });
        });
    };

    var showTab = function(id) {
        $("#" + id + "-tab").addClass('is-active');
        $("#" + id + "-info").show();
    };

    var hideTab = function(id) {
        $("#" + id + "-tab").removeClass('is-active');
        $("#" + id + "-info").hide();
    };

    var changeLocation = function(id) {
        let url =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                '#' + id;
        history.replaceState(url, window.document.title, url);
    };

    return {
        name: "navigationTabs",
        apply: apply
    };
});
